<template>
  <div class="registdemo registbank">
      <h2>
          {{$t('regBank')}}
      </h2>
      <div class="content_wrapper">
          <Form :model="bankModel" :rules="rules" class="inputForm" ref="bankForm" >
            <FormItem  prop="bankName" >
                <effect-input :label='$t("bankName")'  v-model="bankModel.bankName" ></effect-input>
            </FormItem>
            <FormItem  prop="nameOnBankAccount"  >
                <effect-input :label='$t("bankAccountName")'  v-model="bankModel.nameOnBankAccount" :readonly="filterable"></effect-input>
            </FormItem>
            <FormItem  prop="address"  >
                <effect-input :label='$t("bankAddress")'  v-model="bankModel.address" ></effect-input>
            </FormItem>
            <FormItem  prop="country" >
                <effect-select :label='$t("bankCountry")'  v-model="bankModel.country" :options='countryList'  :filterable="filterable"></effect-select>
                <!-- <effect-input :label='$t("basicLast")'  v-model="bankModel.bankCountry" ></effect-input>  -->
             </FormItem>
            <FormItem  prop="iban" >
                <effect-input :label='$t("iban")'  v-model="bankModel.iban" ></effect-input>
            </FormItem>
            <FormItem  prop="swift_BIC"  >
                <effect-input :label='$t("swift")'  v-model="bankModel.swift_BIC" ></effect-input>
            </FormItem>
            <FormItem  prop="accountNumber"  >
                <effect-input :label='$t("accountNumber")'  v-model="bankModel.accountNumber" ></effect-input>
            </FormItem>
            <FormItem  prop="sortCode" >
                <effect-input :label='$t("sortCode")'  v-model="bankModel.sortCode" ></effect-input>
            </FormItem>
            <FormItem  prop="accountCurrency" >
                 <!-- <effect-input :label='$t("basicLast")'  v-model="bankModel.accountCurrency" :isLabel="true"></effect-input>  -->
                <effect-select :label='$t("accountCurrency")'  v-model="bankModel.accountCurrency" :options='currencyOptions' :isLanguage='true'  ></effect-select>
            </FormItem> 
            </Form>
			<Button type="primary" class="formBtn"  @click="ok">{{$t('reg')}}</Button>
			<Button type="primary" class="formBtn"  @click="back">{{$t('back')}}</Button>
      </div>
	    <loading :isSpinShow="loading"></loading>

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import EffectInput from '@/components/EffectInput.vue';
import EffectSelect from '@/components/EffectSelect.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'Home',
  components: {
    EffectSelect,
    EffectInput,
    Loading
  },
  data(){
    return{
        bankModel:{
            bankName: "",
            address: "",
            accountNumber: "",
            nameOnBankAccount: "",
            country: "",
            iban: "",
            swift_BIC: "",
            sortCode: "",
            accountCurrency: ""
        },
		rules:{
			bankName:[{
				required: true,
				message: this.$t('fieldError')
			}],
			address:[{
				required: true,
				message: this.$t('fieldError')
			}],
			accountNumber:[{
				required: true,
				message: this.$t('fieldError')
			}],
			nameOnBankAccount:[{
				required: true,
				message: this.$t('fieldError')
            }],
            country:[{
				required: true,
				message: this.$t('fieldError')
            }],
    //         iban:[{
				// required: true,
				// message: this.$t('fieldError')
    //         }],
            swift_BIC:[{
				required: true,
				message: this.$t('fieldError')
            }],
            // sortCode:[{
			// 	required: true,
			// 	message: this.$t('fieldError')
            // }],
            accountCurrency:[{
				required: true,
				message: this.$t('fieldError')
			}],
		},
		currencyOptions:[
            {
                value:'1',
                label:'USD'
            },
            {
                value:'2',
                label:'EUR'
            },
            {
                value:'3',
                label:'GBP'
            }
        ],
        loading: false,
        countryList:[],
        filterable:true
    }
    
  },
  computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        this.getCountry()
        this.bankModel.nameOnBankAccount = this.userInfo.firstName+' '+this.userInfo.lastName
        if(this.$route.query.id){
            this.getData()
        }
        // console.log(this.bankModel)
    },
    methods:{
        getCountry(){
            this.countryList = []
            this.$axios.get('/api/CreateRealAccount/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString()
                        }
                        if(this.lang == 'zh'){
                            data.label = e.nameCN
                        }else{
                            data.label = e.name
                        }
                        this.countryList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        getData(){
            this.$axios.get('/api/UserInfo/GetBankInfoById',{
				params:{
					id:this.$route.query.id
				}
			})
            .then(async (res) => {
                console.log(res)
                let dt = res.data
                if(dt.status == 1){
                    this.bankModel = dt.obj
                }else{
                    this.$Message.error(dt.msg)
                }
            })
            .catch((err) => {
				this.loading = false
			})
        },
        ok () {
        	this.$refs['bankForm'].validate((valid) => {
        		if (valid) {
					this.loading = true
        			this.$axios.post('/api/UserInfo/AddBankInfo',this.bankModel)
        			.then(async (res) => {
        				let dt = res.data
						this.loading = false
        			    if(dt.status == 1){
        					this.$Message.success(dt.msg)
        			    }else{
        			        this.$Message.error(dt.msg)
        			    }
        			}).catch(() => {
						this.loading = false
					})
        		}
        	})
        },
        back(){
            this.$router.push({path:'/bankList'})
        }
    }
}
</script>

<style lang="less">
.registbank{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
	.inputForm{
		justify-content: space-between!important;
	}
    .ivu-form-item{
        width: 48%;
    }
	.formBtn{
		min-width: 230px;
	}
	// .ivu-form-item-error {
	// 	.ivu-select-selection{
	// 		border: 1px solid #ed4014!important;
	// 	}
	// }
	.demo-spin-icon-load{
		animation: ani-demo-spin 1s linear infinite;
	}
}

@keyframes ani-demo-spin {
	from { transform: rotate(0deg);}
	50%  { transform: rotate(180deg);}
	to   { transform: rotate(360deg);}
}
</style>
